import "./app.scss";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoginPage from "./pages/login.js";
import { DashboardPage } from "./pages/dashboard.js";
import SignupPage from "./pages/signup.js";
import ForgotPasswordPage from "./pages/forgotPassword.js";
import ResetPasswordPage from "./pages/resetPassword.js";
import NotFound from "./pages/404.js";
import { ToastContainer } from "react-toastify";

function App() {
  return (
    <div className="App">
      <ToastContainer position="top-center" rtl={true} closeButton={false} style={{fontSize:"0.875rem"}}/>
       <HelmetProvider>
        <Helmet>
          <meta charSet="utf-8" />
        </Helmet>
      </HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" exact element={<LoginPage />} />
          <Route path="dashboard" exact element={<DashboardPage />} />
          <Route
            path="signup"
            exact
            element={<SignupPage />}
          />
          <Route
            path="forgotPassword"
            exact
            element={<ForgotPasswordPage />}
          />
          <Route
            path="resetPassword"
            exact
            element={<ResetPasswordPage />}
          />
          <Route path="/*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
